import React from 'react';

import {StyledTableHeaderCell} from './table-helpers';
import {Column} from 'commons/models/components/EfeTableValues';
import {Box, Grid} from '@material-ui/core';

type Props = {
    column: Column;
    index: number;
};

function EfeHeaderTable(props: Props) {
    const {column, index} = props;

    function header(data: Column) {
        if (data.headerType === 'text') {
            return (
                <Box display='flex' flexDirection='row' justifyContent='center' mt={2}>
                    <Grid container spacing={2} justifyContent={'space-between'}>
                        {data.header}
                    </Grid>
                </Box>
            );
        } else {
            return (
                <Box display='flex' flexDirection='row' justifyContent='center' mt={2}>
                    <Grid container spacing={2} justifyContent={'space-between'}>
                        Error. Tipo de encabezado no reconocido.
                    </Grid>
                </Box>
            );
        }
    }

    return (
        <StyledTableHeaderCell component='th' scope='row' key={index}>
            {header(column)}
        </StyledTableHeaderCell>
    );
}

export default EfeHeaderTable;
